// extracted by mini-css-extract-plugin
export default {"imageWrapper":"UserMenu_imageWrapper__f-OzA"};